"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./polyfills');
var toggle_open_1 = require("./common/toggle-open");
var toggle_hidden_1 = require("./common/toggle-hidden");
var scroll_detect_1 = require("./common/scroll-detect");
var expand_1 = require("./common/expand");
var effects_1 = require("./common/effects");
var upload_1 = require("./common/upload");
var Base = /** @class */ (function () {
    function Base(documentObject) {
        new toggle_open_1.default(documentObject);
        new toggle_hidden_1.default(documentObject);
        new scroll_detect_1.default(documentObject);
        new expand_1.default(documentObject);
        new effects_1.default(documentObject);
        new upload_1.default(documentObject);
    }
    return Base;
}());
exports.default = Base;
